var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPage51(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 40,
    viewBox: "0 0 50 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img_123"
  }, /*#__PURE__*/React.createElement("g", {
    id: 123
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_ii_10606_3379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.3687 14.3703C33.5913 14.0903 33.1289 13.2467 33.5546 12.5385C33.6373 12.401 33.7268 12.2673 33.823 12.1382C34.1921 11.6395 34.6675 11.1936 35.2101 10.8242C35.7324 10.4563 36.3221 10.1649 36.9571 9.93105C37.5734 9.71915 38.2164 9.58682 38.8861 9.53406C39.7384 9.46692 40.5597 9.52473 41.3484 9.68721C42.1388 9.86998 42.8356 10.1622 43.4577 10.542C44.0611 10.9437 44.5475 11.4159 44.9389 11.9772C45.3115 12.5604 45.5469 13.2157 45.6045 13.9463C45.6333 14.3116 45.6012 14.6817 45.5472 15.033C45.4745 15.4063 45.358 15.7422 45.1977 16.0407C45.0204 16.3814 44.7773 16.666 44.5092 16.8913C44.2845 17.1021 44.3437 17.6959 44.6217 17.8289C44.6295 17.8327 44.6374 17.8365 44.6452 17.8403C44.9875 18.0379 45.3127 18.2778 45.5989 18.5411C45.868 18.8466 46.0981 19.1756 46.2892 19.5281C46.443 19.9244 46.5561 20.3239 46.5897 20.75C46.6568 21.6023 46.5317 22.3473 46.2176 23.0255C45.9035 23.7036 45.4596 24.2899 44.886 24.7843C44.2905 25.2601 43.5855 25.6423 42.7929 25.9498C41.9785 26.2385 41.1154 26.429 40.2022 26.501C39.5528 26.5521 38.9174 26.5205 38.2584 26.4499C37.5775 26.3606 36.9308 26.187 36.3402 25.9476C35.7074 25.6912 35.1494 25.3472 34.6459 24.9172C34.4903 24.7843 34.3432 24.6454 34.2054 24.4982C33.636 23.89 33.9504 22.9692 34.6777 22.5628L35.2272 22.2557C36.065 21.7876 37.1295 22.2521 37.9984 22.6597C38.0062 22.6633 38.014 22.667 38.0219 22.6705C38.5751 22.9537 39.1764 23.0697 39.8461 23.0169C40.1708 22.9913 40.4736 22.9471 40.7919 22.8403C41.0931 22.7757 41.3692 22.6519 41.6218 22.489C41.8558 22.3481 42.0646 22.1479 42.2094 21.9119C42.3354 21.6977 42.3958 21.4275 42.3702 21.1028C42.3415 20.7376 42.216 20.4411 42.0345 20.2104C41.86 20.0284 41.657 19.8796 41.4246 19.7507C41.3556 19.7124 41.2827 19.6818 41.2074 19.6582C40.9468 19.5766 40.6722 19.5136 40.3845 19.4828C40.016 19.471 39.6881 19.456 39.3634 19.4815L39.2619 19.4895C38.4101 19.5566 37.6652 18.9205 37.5981 18.0687C37.531 17.2169 38.1671 16.472 39.0189 16.4049L39.1204 16.3969C39.3842 16.3762 39.6667 16.3335 39.946 16.2502C40.2269 16.1872 40.4844 16.0853 40.7167 15.9241C40.9303 15.7847 41.1002 15.608 41.2449 15.372C41.371 15.1578 41.4298 14.8673 41.4026 14.5223C41.3802 14.2382 41.3002 13.9995 41.1608 13.7859C41.0028 13.5941 40.8074 13.4462 40.5932 13.3201C40.3604 13.2159 40.1089 13.1336 39.8387 13.0732C39.5498 13.0347 39.2625 13.0165 38.9784 13.0389C38.4102 13.0837 37.8969 13.3079 37.4558 13.6694C37.4211 13.6982 37.3874 13.7277 37.3545 13.7578C36.6885 14.3669 35.7917 14.8829 34.9425 14.577L34.3687 14.3703Z",
    fill: "#95CD0B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2",
    filter: "url(#filter1_ii_10606_3379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4341 23.5047C23.4501 22.9182 24.2649 22.3011 24.9016 21.6363C25.495 20.9854 25.8609 20.3411 25.959 19.6971C25.9897 19.4959 25.9862 19.2483 25.9828 19.0007C25.936 18.767 25.8692 18.5303 25.7791 18.3107C25.6457 18.105 25.4891 17.9164 25.266 17.7589C25.043 17.6013 24.7503 17.495 24.3881 17.4397C22.8989 17.2128 21.6742 17.9527 20.7603 19.6255L17.8152 17.4675C18.1268 16.7737 18.547 16.1788 19.0756 15.6828C19.5841 15.1838 20.1577 14.7976 20.8228 14.4871C21.4414 14.2108 22.1485 14.0303 22.9036 13.9395C23.6355 13.8657 24.3924 13.8987 25.1974 14.0214C26.0194 14.1673 26.7827 14.4277 27.4673 14.7998C28.1287 15.1889 28.6974 15.6462 29.147 16.2089C29.5966 16.7716 29.9101 17.4166 30.1107 18.1266C30.2882 18.8538 30.3125 19.64 30.1697 20.4419C30.0374 21.0395 29.854 21.5675 29.573 22.06C29.2688 22.5696 28.9104 23.0298 28.5148 23.4637C28.096 23.9146 27.6431 24.3192 27.1329 24.6945C26.6197 25.0898 26.0723 25.4388 25.528 25.7677L23.4465 26.9948L29.6648 27.9426L29.1403 31.3837L16.4421 29.4483L16.8531 26.7517L22.4341 23.5047Z",
    fill: "#DE6969"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3",
    filter: "url(#filter2_ii_10606_3379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.68611 10.3046C6.77749 9.41906 7.56945 8.77525 8.45502 8.86662L11.8897 9.22103C12.7753 9.31241 13.4191 10.1044 13.3277 10.9899L11.9934 23.9213C11.902 24.8069 11.1101 25.4507 10.2245 25.3593L9.21965 25.2556C8.33408 25.1643 7.69027 24.3723 7.78164 23.4867L8.79669 13.6496C8.86592 12.9786 8.37811 12.3786 7.70712 12.3093C7.03613 12.2401 6.54832 11.64 6.61755 10.969L6.68611 10.3046Z",
    fill: "#FFB800"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_10606_3379",
    x: 32.5846,
    y: 8.69987,
    width: 14.8268,
    height: 18.6315,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.805985,
    dy: -0.805985
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.805985
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "color-burn",
    in2: "shape",
    result: "effect1_innerShadow_10606_3379"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.805985,
    dy: 0.805985
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.805985
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_10606_3379",
    result: "effect2_innerShadow_10606_3379"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_10606_3379",
    x: 15.6354,
    y: 13.0944,
    width: 15.4323,
    height: 19.0944,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.805985,
    dy: -0.805985
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.805985
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "color-burn",
    in2: "shape",
    result: "effect1_innerShadow_10606_3379"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.805985,
    dy: 0.805985
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.805985
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_10606_3379",
    result: "effect2_innerShadow_10606_3379"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_10606_3379",
    x: 5.80339,
    y: 8.05144,
    width: 8.33853,
    height: 18.1217,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.805985,
    dy: -0.805985
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.805985
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "color-burn",
    in2: "shape",
    result: "effect1_innerShadow_10606_3379"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.805985,
    dy: 0.805985
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.805985
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_10606_3379",
    result: "effect2_innerShadow_10606_3379"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage51);
export default __webpack_public_path__ + "static/media/page5_1.857d2d5854ae4383c7c00079770bdf77.svg";
export { ForwardRef as ReactComponent };